import ProductCatalogRoot from '../components/micro-front-ends/ProductCatalog'

export default [
  {
    path: '/product-catalog*',
    meta: { showSideNav: true },
    name: 'ProductCatalog',
    component: ProductCatalogRoot
  }
]
